<div class="edit-toggle-page">
	@if (company) {
		<div class="content-container column">
			<div class="content-container-header flex-row flex-wrap">
				<div>
					<h3 class="flex-grow header-h3" i18n="@@companyAbout-title">About the company</h3>
					<p class="header-subtext" i18n="@@companyAbout-informationNotice">
						The following information will be added to the public directory.
					</p>
				</div>
				@if (canEditPublicInfo) {
					@if (editingPublicInfo === false) {
						<div>
							<button
								(click)="editPublicInfoButtonClicked()"
								class="primary-small-button"
								data-automation-id="company-about-edit-button"
								i18n="@@companyAbout-detailEdit"
							>
								Edit
							</button>
						</div>
					} @else {
						<div>
							<button
								class="secondary-small-button"
								(click)="editPublicInfoCancelButtonClicked()"
								i18n="@@companyAbout-detailCancel"
								data-automation-id="company-about-cancel-button"
							>
								Cancel
							</button>
							<button
								(click)="savePublicInfoEdits()"
								class="primary-small-button"
								data-automation-id="company-about-save-changes-button"
								i18n="@@companyAbout-detailSave"
							>
								Save Changes
							</button>
						</div>
					}
				}
			</div>
			<mat-divider></mat-divider>
			<div class="content-container-body column spacing-24">
				@if (!editingPublicInfo) {
					<div class="row">
						<div class="row bottom-padding">
							<table style="width: 100%">
								<tr class="mat-body-2">
									<td class="width-25-grey-no-bold" i18n="@@companyAbout-viewName">Name</td>
									<td class="width-25-grey-no-bold" i18n="@@companyAbout-viewStatus">Status</td>
									<td class="width-25 padding-for-td">&nbsp;</td>
									<td class="width-25 padding-for-td">&nbsp;</td>
								</tr>
								<tr class="mat-body-3">
									<td class="table-body-text padding-for-td">{{ this.company.name }}</td>
									<td class="table-body-text padding-for-td">
										<mat-chip-set>
											<mat-chip class="status-chip" [ngClass]="getChipStyling(this.company.active)"
												>&bull;&NonBreakingSpace;{{ displayStatusName(this.company.active) }}</mat-chip
											>
										</mat-chip-set>
									</td>
									<td class="width-25 padding-for-td">&nbsp;</td>
									<td class="width-25 padding-for-td">&nbsp;</td>
								</tr>
							</table>
						</div>
						<div class="row top-bottom-padding">
							<table
								style="
									width: 100%;
									table-layout: fixed;
									margin-left: auto;
									margin-right: auto;
									border-collapse: collapse;
								"
							>
								<tr class="mat-body-2">
									<td class="width-25-grey-no-bold" i18n="@@companyAbout-viewCountry">Country</td>
									<td class="width-25-grey-no-bold" i18n="@@companyAbout-timezone">Timezone</td>
									<td class="width-25-grey-no-bold" i18n="@@companyAbout-viewTaxID">Tax ID</td>
									<td class="width-25 padding-for-td">&nbsp;</td>
								</tr>
								<tr class="mat-body-3">
									<td class="table-body-text padding-for-td">{{ this.company.address.countryCode ?? '---' }}</td>
									<td class="table-body-text padding-for-td">
										{{ this.company.timezone ?? '---' }}
										@if (this.timezone?.name) {
											- {{ this.timezone?.description }}
										}
									</td>
									<td class="table-body-text padding-for-td">{{ this.company.taxId ?? '---' }}</td>
									<td class="width-25 padding-for-td">&nbsp;</td>
								</tr>
							</table>
						</div>
					</div>
					<mat-divider></mat-divider>
					<div class="row">
						<div class="row top-bottom-padding">
							<table style="width: 100%">
								<tr class="mat-body-2">
									<td class="width-25-grey-no-bold" i18n="@@companyAbout-viewStreetAddress">Street Address</td>
									<td class="width-25-grey-no-bold" i18n="@@companyAbout-viewApartmentSuite">
										Apartment/Suite (optional)
									</td>
									<td class="width-25 padding-for-td">&nbsp;</td>
									<td class="width-25 padding-for-td">&nbsp;</td>
								</tr>
								<tr class="mat-body-3">
									<td class="table-body-text">{{ this.company.address.address1 ?? '---' }}</td>
									<td class="table-body-text">{{ this.company.address.address2 ?? '---' }}</td>
								</tr>
							</table>
						</div>
						<div class="row top-bottom-padding">
							<table style="width: 100%">
								<tr class="mat-body-2">
									<td class="width-25-grey-no-bold" i18n="@@companyAbout-viewTownCity">Town/City</td>
									<td class="width-25-grey-no-bold" i18n="@@companyAbout-viewStateProvince">State/Province</td>
									<td class="width-25-grey-no-bold" i18n="@@companyAbout-viewPostalCode">Postal Code</td>
									<td class="width-25 padding-for-td">&nbsp;</td>
								</tr>
								<tr class="mat-body-3">
									<td class="table-body-text">{{ this.company.address.locality ?? '---' }}</td>
									<td class="table-body-text">{{ this.company.address.stateProvinceRegion ?? '---' }}</td>
									<td class="table-body-text">{{ this.company.address.postalCode ?? '---' }}</td>
								</tr>
							</table>
						</div>
					</div>
					@if (isSentriKeyAccessUser) {
						<mat-divider></mat-divider>
						<h3 class="flex-grow header-h3 company-type-section-header" i18n="@@companyAbout-companyTypeTitle">
							Company Type
						</h3>
						<div class="column">
							@if (company.companyType === 'care') {
								<div class="company-type-container">
									<h3 class="company-type-heading" i18n="@@companyAbout-viewCompanyTypeCare">Care</h3>
									<p class="company-type-description" i18n="@@companyAbout-viewCompanyTypeCareDesc">
										Dedicated access management for home health and patient care professionals.
									</p>
								</div>
							}
							@if (company.companyType !== 'care') {
								<div class="company-type-container">
									<h3 class="company-type-heading" i18n="@@companyAbout-viewCompanyTypeStandard">Standard</h3>
									<p class="company-type-description" i18n="@@companyAbout-viewCompanyTypeStandardDesc">
										Full-feature management for large organizations with multiple sub-companies.
									</p>
								</div>
							}
						</div>
					}
				} @else {
					<div class="row spacing-24">
						<mat-form-field subscriptSizing="dynamic" class="column" appearance="outline">
							<mat-label i18n="@@companyAbout-editCompanyName">Name</mat-label>
							<input
								matInput
								[(ngModel)]="editCompany.name"
								[disabled]="!hasGCM"
								data-automation-id="edit-company-name-input"
							/>
						</mat-form-field>
						<mat-form-field subscriptSizing="dynamic" appearance="outline" class="column">
							<mat-label i18n="@@companyAbout-editStatuts">Status</mat-label>
							<mat-select
								disableOptionCentering
								[(ngModel)]="editCompany.active"
								[disabled]="!canEditPublicInfo"
								data-automation-id="status-picker"
							>
								@for (option of activeOptions; track option) {
									<mat-option [value]="option.value" [attr.data-automation-id]="'status-' + option.value">
										{{ option.label }}
									</mat-option>
								}
							</mat-select>
						</mat-form-field>
						<div class="column"></div>
					</div>
					<div class="row spacing-24">
						<mat-form-field subscriptSizing="dynamic" class="column" appearance="outline">
							<mat-label
								[ngClass]="!canEditPublicInfo || !this.editCompany ? 'disabled-color' : 'mat-label-color'"
								i18n="@@companyAbout-editCountry"
								>Country</mat-label
							>
							<input
								type="text"
								data-automation-id="country-input"
								[required]="true"
								aria-label="Country"
								[disabled]="!canEditPublicInfo || !this.editCompany"
								[ngClass]="{ 'disabled-color': !canEditPublicInfo || !this.editCompany }"
								matInput
								[matAutocomplete]="auto"
								[matAutocompleteDisabled]="!canEditPublicInfo || !this.editCompany"
								name="countryCode"
								[(ngModel)]="editCompany.countryCode"
								(ngModelChange)="filterCountries($event)"
								(click)="openAutocompleteCountries()"
								(input)="countryInput()"
							/>
							<mat-autocomplete
								#auto="matAutocomplete"
								[displayWith]="displayCountryName"
								(optionSelected)="countrySelected()"
								data-automation-id="country-picker"
							>
								@for (country of filteredCountries | async; track country.twoLetterCode) {
									<mat-option
										[value]="country.twoLetterCode"
										[disabled]="!canEditPublicInfo || !this.editCompany"
										[attr.data-automation-id]="'country-' + country.twoLetterCode"
									>
										{{ country.name }}
									</mat-option>
								}
							</mat-autocomplete>
							@if (showCountryError) {
								<mat-hint i18n="@@companyAbout-editCountryError" data-automation-id="country-error">
									Please select a Country from the list
								</mat-hint>
							}
						</mat-form-field>
						<mat-form-field subscriptSizing="dynamic" class="column" appearance="outline">
							<mat-label class="mat-label-color" i18n="@@companyAbout-editTimezone">Timezone</mat-label>
							<input [disabled]="true" data-automation-id="timezone-input" matInput [(ngModel)]="displayTimezone" />
						</mat-form-field>
						<mat-form-field subscriptSizing="dynamic" class="column" appearance="outline">
							<mat-label i18n="@@companyAbout-editTaxID">Tax ID</mat-label>
							<input
								matInput
								[(ngModel)]="editCompany.taxId"
								[disabled]="!canEditPublicInfo"
								data-automation-id="tax-id-input"
							/>
						</mat-form-field>
					</div>
					<mat-divider></mat-divider>
					<div class="row spacing-24 margin-top-16">
						<mat-form-field subscriptSizing="dynamic" class="column" appearance="outline">
							<mat-label i18n="@@companyAbout-editAddress">Street Address</mat-label>
							<input
								matInput
								[(ngModel)]="editCompany.address1"
								[disabled]="!canEditPublicInfo"
								data-automation-id="address-input"
							/>
						</mat-form-field>
						<mat-form-field subscriptSizing="dynamic" class="column" appearance="outline">
							<mat-label i18n="@@companyAbout-editApartment">Apartment/Suite (optional)</mat-label>
							<input
								matInput
								[(ngModel)]="editCompany.address2"
								[disabled]="!canEditPublicInfo"
								data-automation-id="apartment-input"
							/>
						</mat-form-field>
						<div class="column"></div>
					</div>
					<div class="row spacing-24">
						<mat-form-field subscriptSizing="dynamic" class="column" appearance="outline">
							<mat-label i18n="@@companyAbout-editTown">Town / City</mat-label>
							<input
								matInput
								[(ngModel)]="editCompany.locality"
								[disabled]="!canEditPublicInfo"
								data-automation-id="city-input"
							/>
						</mat-form-field>
						<mat-form-field subscriptSizing="dynamic" class="column" appearance="outline">
							<mat-label i18n="@@companyAbout-editState">State / Province</mat-label>
							<input
								matInput
								[(ngModel)]="editCompany.stateProvinceRegion"
								[disabled]="!canEditPublicInfo"
								data-automation-id="province-input"
							/>
						</mat-form-field>
						<mat-form-field subscriptSizing="dynamic" class="column" appearance="outline">
							<mat-label i18n="@@companyAbout-editPostal">Postal Code</mat-label>
							<input
								matInput
								[(ngModel)]="editCompany.postalCode"
								[disabled]="!canEditPublicInfo"
								data-automation-id="postal-code-input"
							/>
						</mat-form-field>
					</div>
				}
			</div>
		</div>
	}

	<p>&nbsp;</p>

	@if (relationship) {
		<div class="content-container column">
			<div class="content-container-header flex-row flex-wrap">
				<div>
					<h3 class="flex-grow header-h3" i18n="@@companyAbout-companyRelationship">Company Relationship</h3>
					<p class="header-subtext" i18n="@@companyAbout-privateinfo">
						The following information will be private to your company.
					</p>
				</div>
				@if (canEditPrivateInfo) {
					@if (editingPrivateInfo === false) {
						<div>
							<button
								(click)="editPrivateInfoButtonClicked()"
								class="primary-small-button"
								i18n="@@companyAbout-relationshipEdit"
								data-automation-id="company-about-edit-two-button"
							>
								Edit
							</button>
						</div>
					} @else {
						<div>
							<button
								class="secondary-small-button"
								(click)="editPrivateInfoCancelButtonClicked()"
								i18n="@@companyAbout-relationshipCancel"
								data-automation-id="company-about-cancel-two-button"
							>
								Cancel
							</button>
							<button
								(click)="savePrivateInfoEdits()"
								class="primary-small-button"
								i18n="@@companyAbout-relationshipSave"
								data-automation-id="company-about-save-changes-two-button"
							>
								Save Changes
							</button>
						</div>
					}
				}
			</div>
			<mat-divider></mat-divider>
			<div class="content-container-body column spacing-24">
				@if (!editingPrivateInfo) {
					<div class="row">
						<div class="row bottom-padding">
							<table style="width: 100%">
								<tr class="mat-body-2">
									<td class="width-25-grey-no-bold" i18n="@@companyAbout-viewCompanyID">Company ID (optional)</td>
									<td class="width-25-grey-no-bold" i18n="@@companyAbout-viewRelationshipType">Relationship Type</td>
									<td class="width-25-grey-no-bold" i18n="@@companyAbout-viewRelationshipStatus">Status</td>
									<td class="width-25 padding-for-td">&nbsp;</td>
								</tr>
								<tr class="mat-body-3">
									<td class="table-body-text">{{ this.relationship.detail?.externalId ?? '---' }}</td>
									<td class="table-body-text">
										{{
											this.relationship.relationshipType
												? this.relationship.relationshipType.charAt(0).toUpperCase() +
													this.relationship.relationshipType.slice(1)
												: '---'
										}}
									</td>
									<td class="table-body-text">
										<mat-chip-set>
											<mat-chip class="status-chip" [ngClass]="getChipStyling(this.relationship.active)"
												>&bull;&NonBreakingSpace;{{ displayStatusName(this.relationship.active) }}</mat-chip
											>
										</mat-chip-set>
									</td>
								</tr>
							</table>
						</div>
						<div class="row top-bottom-padding">
							<table style="width: 100%">
								<tr class="mat-body-2">
									<td class="width-27-grey-no-bold" i18n="@@companyAbout-viewNotes">Notes (optional)</td>
									<td class="width-25 padding-for-td">&nbsp;</td>
								</tr>
								<tr class="mat-body-3">
									<td class="table-body-text">{{ this.relationship.detail?.notes ?? '---' }}</td>
								</tr>
							</table>
						</div>
					</div>
				} @else {
					<div class="row spacing-24">
						<mat-form-field subscriptSizing="dynamic" appearance="outline" class="column">
							<mat-label i18n="@@companyAbout-editCompanyID">Company ID (optional)</mat-label>
							<input
								matInput
								[(ngModel)]="editRelationship.externalId"
								[disabled]="!canEditPrivateInfo"
								data-automation-id="company-id-input"
							/>
						</mat-form-field>
						<mat-form-field subscriptSizing="dynamic" appearance="outline" class="column">
							<mat-label i18n="@@companyAbout-editRelationshipType">Relationship Type</mat-label>
							<mat-select
								disableOptionCentering
								[(ngModel)]="editRelationship.relationshipType"
								[disabled]="!canEditPrivateInfo"
								data-automation-id="relationship-type-picker"
							>
								@for (option of relationshipTypeOptions; track option) {
									<mat-option [value]="option.value" [attr.data-automation-id]="'relationship-type-' + option.label">
										{{ option.label }}
									</mat-option>
								}
							</mat-select>
						</mat-form-field>
						<mat-form-field subscriptSizing="dynamic" appearance="outline" class="column">
							<mat-label i18n="@@companyAbout-editStatus">Status</mat-label>
							<mat-select
								disableOptionCentering
								[(ngModel)]="editRelationship.active"
								[disabled]="!canEditPrivateInfo"
								data-automation-id="status-picker"
							>
								@for (option of activeOptions; track option) {
									<mat-option [value]="option.value" [attr.data-automation-id]="'status-' + option.label">
										{{ option.label }}
									</mat-option>
								}
							</mat-select>
						</mat-form-field>
					</div>
					<div class="row spacing-24">
						<mat-form-field subscriptSizing="dynamic" class="column" appearance="outline">
							<mat-label i18n="@@companyAbout-editNotes">Notes (optional)</mat-label>
							<textarea
								#txtarea
								matInput
								matInput
								[(ngModel)]="editRelationship.notes"
								maxlength="2000"
								[disabled]="!canEditPrivateInfo"
								data-automation-id="notes-textarea"
							></textarea>
						</mat-form-field>
					</div>
				}
			</div>
		</div>
	}

	<p>&nbsp;</p>

	<!-- show company settings for related companies, active company, Oracle, GCM act, or GCM View (Support read-only) -->
	@if (relationship || this.isEditingActiveCompany || this.isOracle || this.hasGCM || this.hasGcmView) {
		<div class="content-container column">
			<div class="content-container-header flex-row flex-wrap">
				<div>
					<h3 class="flex-grow header-h3" i18n="@@companyAbout-companySettings">Company Settings</h3>
					<p class="header-subtext" i18n="@@companyAbout-companySettingsInfo">
						Allows users to customize and manage company settings.
					</p>
				</div>
				@if (canEditCompanySetting || hasGCM) {
					@if (editingCompanySetting === false) {
						<div>
							<button
								(click)="editCompanySettingButtonClicked()"
								class="primary-small-button"
								i18n="@@companyAbout-editingCompanySettingEdit"
								data-automation-id="company-about-edit-three-button"
							>
								Edit
							</button>
						</div>
					} @else {
						<div>
							<button
								class="secondary-small-button"
								(click)="editCompanySettingCancelButtonClicked()"
								i18n="@@companyAbout-editingCompanySettingCancel"
								data-automation-id="company-about-cancel-three-button"
							>
								Cancel
							</button>
							<button
								(click)="editCompanySettingSaveButtonClicked()"
								class="primary-small-button"
								data-automation-id="company-about-save-changes-three-button"
								i18n="@@companyAbout-editingCompanySettingSave"
							>
								Save Changes
							</button>
						</div>
					}
				}
			</div>
			<mat-divider></mat-divider>
			<div class="content-container-body column spacing-24">
				@if (!editingCompanySetting) {
					<div class="column spacing-24">
						<!-- Alerts & Notifications -->
						@if (hasAlertsAndNotificationsContent()) {
							<section class="company-settings-section">
								<h4 class="company-settings-section-header" i18n="@@companyAbout-alertsAndNotifications">
									Alerts & Notifications
								</h4>
								<div class="company-settings-section-body column spacing-24">
									@if ((this.company.keyDetection && !isOracle) || isOracle) {
										<div class="row">
											<div class="column width-100-grey">
												<span i18n="@@companyAbout-viewKeyDetection">Key Detection</span>
											</div>
											<div class="column company-text-settings">
												<span>{{ this.company.keyDetection ? settingOn : settingOff }}</span>
											</div>
										</div>
									}
									@if (isOracle) {
										<div class="row">
											<div class="column width-100-grey">
												<span i18n="@@companyAbout-companySettingsSmsSwitch">Allow SMS Notifications</span>
											</div>
											<div class="column company-text-settings">
												<span>{{ this.company.smsNotifications ? settingOn : settingOff }}</span>
											</div>
										</div>
									}
									@if (isSentriKeyAccessUser || (isEditingActiveCompany && !!this.company.contactNotifications)) {
										<div class="row">
											<div class="column width-100-grey">
												<span i18n="@@companyAbout-companySettingsContactNotifications">Contact Notifications</span>
											</div>
											<div class="column company-text-settings">
												<span>{{ this.company.contactNotifications ? settingOn : settingOff }}</span>
											</div>
										</div>
									}
								</div>
							</section>
						}
						<!-- Device Management -->
						@if (hasDeviceManagementContent()) {
							<section class="company-settings-section">
								<h4 class="company-settings-section-header" i18n="@@companyAbout-deviceManagement">
									Device Management
								</h4>
								<div class="company-settings-section-body column spacing-24">
									@if (isOracle || (isEditingActiveCompany && this.company.deviceRemovalAccessOptions)) {
										<div class="row">
											<div class="column width-100-grey">
												<span i18n="@@companyAbout-viewDeviceRemovalAccessOptions">Device Removal Access Options</span>
											</div>
											<div class="column company-text-settings">
												<span>{{ this.company.deviceRemovalAccessOptions ? settingOn : settingOff }}</span>
											</div>
										</div>
									}
									@if (isOracle || isEditingActiveCompany) {
										<div class="row">
											<div class="column width-100-grey">
												<span
													i18n="@@companyAbout-viewRequireReasonForCodeGeneration"
													data-automation-id="companySettings-requireReasonForCodeGenerationStaticText"
													>Require Reason for Code Generation</span
												>
											</div>
											<div class="column company-text-settings">
												<span>{{ company.requireReasonForCodeGeneration ? settingOn : settingOff }}</span>
											</div>
										</div>
									}
								</div>
							</section>
						}
						<!-- Privacy & Compliance -->
						<section class="company-settings-section">
							<h4 class="company-settings-section-header" i18n="@@companyAbout-privacyAndCompliance">
								Privacy & Compliance
							</h4>
							<div class="company-settings-section-body column spacing-24">
								@if (isOracle || isSentriKeyAccessUser) {
									<div class="row">
										<div class="column width-100-grey">
											<span
												i18n="@@companyAbout-viewHideFromPublicDirectory"
												data-automation-id="companySettings-HideFromPublicDirectoryStaticText"
												>Hide from Public Directory</span
											>
										</div>
										<div class="column company-text-settings">
											<span>{{ this.company.hideFromPublicDirectory ? settingOn : settingOff }}</span>
										</div>
									</div>
								}
								<div class="row">
									<div class="column width-100-grey">
										<span i18n="@@companyAbout-viewDeidentification">
											What is the time frame before the company undergoes de-identification?
										</span>
									</div>
									<div class="column company-text-settings">
										@if (!this.company.deidentification) {
											<span> - </span>
										}
										@if (this.company.deidentification) {
											<span i18n="@@companyAbout-viewDeidentificationMonths">
												{{ this.company.deidentification }} months
											</span>
										}
									</div>
								</div>
							</div>
						</section>
						<!-- System Integrations -->
						@if (hasSystemIntegrationsContent()) {
							<section class="company-settings-section">
								<h4 class="company-settings-section-header" i18n="@@companyAbout-systemIntegrations">
									System Integrations
								</h4>
								<div class="company-settings-section-body column spacing-24">
									@if (isSentriKeyAccessUser || (isEditingActiveCompany && !!this.company.ajaxEnabled)) {
										<div class="row">
											<div class="column width-100-grey">
												<span i18n="@@companyAbout-ajaxIntegration">AJAX Integration</span>
											</div>
											<div class="column company-text-settings">
												<span>{{ this.company.ajaxEnabled ? settingOn : settingOff }}</span>
											</div>
										</div>
									}
									@if (isOracle) {
										<div class="row">
											<div class="column width-100-grey">
												<span i18n="@@companyAbout-viewApiEnabled">Will the company be using our API?</span>
											</div>
											<div class="column company-text-settings">
												<span>{{ this.company.apiEnabled ? settingOn : settingOff }}</span>
											</div>
										</div>
									}
									@if (isOracle && company.apiUsernames && company.apiUsernames.length > 0) {
										<div class="row api-usernames-row">
											<div class="column company-text-settings">
												@for (apiUsername of company.apiUsernames; track apiUsername) {
													<div class="row">
														<div>{{ apiUsername }}</div>
													</div>
												}
											</div>
											<div class="column width-100-grey"></div>
										</div>
									}
								</div>
							</section>
						}
					</div>
				} @else {
					<div class="column spacing-24">
						<!-- Alerts & Notifications -->
						@if (hasAlertsAndNotificationsContent()) {
							<section class="company-settings-section">
								<h4 class="company-settings-section-header" i18n="@@companyAbout-alertsAndNotifications">
									Alerts & Notifications
								</h4>
								<div class="company-settings-section-body column spacing-24">
									@if ((this.company.keyDetection && !isOracle) || isOracle) {
										<span class="row">
											<span class="column width-100-grey" i18n="@@companyAbout-keyDetection">Key Detection</span>
											<div class="column">
												<mat-slide-toggle
													[(ngModel)]="editCompany.keyDetection"
													[disabled]="!canEditCompanySetting || isCompanyAdmin"
													data-automation-id="key-detection-toggle"
												>
												</mat-slide-toggle>
											</div>
										</span>
									}
									@if (isOracle) {
										<span class="row">
											<span class="column width-100-grey" i18n="@@companyAbout-companySettingsSmsSwitch"
												>Allow SMS Notifications</span
											>
											<div class="column">
												<mat-slide-toggle
													[(ngModel)]="editCompany.smsNotifications"
													[disabled]="!canEditCompanySetting || isCompanyAdmin"
													data-automation-id="sms-toggle"
												>
												</mat-slide-toggle>
											</div>
										</span>
									}
									@if (isSentriKeyAccessUser || (isEditingActiveCompany && !!this.company.contactNotifications)) {
										<span class="row">
											<span class="column width-100-grey" i18n="@@companyAbout-companySettingsContactNotifications"
												>Contact Notifications</span
											>
											<div class="column">
												<mat-slide-toggle
													[(ngModel)]="editCompany.contactNotifications"
													[disabled]="!isContactNotificationsEnabled() || !(isSentriKeyAccessUser && hasGCM)"
													data-automation-id="contact-notifications-toggle"
												>
												</mat-slide-toggle>
											</div>
										</span>
									}
								</div>
							</section>
						}
						<!-- Device Management -->
						@if (hasDeviceManagementContent()) {
							<section class="company-settings-section">
								<h4 class="company-settings-section-header" i18n="@@companyAbout-deviceManagement">
									Device Management
								</h4>
								<div class="company-settings-section-body column spacing-24">
									@if (isOracle || (isEditingActiveCompany && this.company.deviceRemovalAccessOptions)) {
										<span class="row">
											<span class="column width-100-grey" i18n="@@companyAbout-editDeviceRemovalAccessOptions"
												>Device Removal Access Options</span
											>
											<div class="column">
												<mat-slide-toggle
													[(ngModel)]="editCompany.deviceRemovalAccessOptions"
													[disabled]="!isOracle"
													data-automation-id="device-removal-access-options-toggle"
												>
												</mat-slide-toggle>
											</div>
										</span>
									}
									@if (isOracle || isEditingActiveCompany) {
										<span class="row">
											<span
												class="column width-100-grey"
												i18n="@@companyAbout-requireReasonForCodeGeneration"
												data-automation-id="companySettings-requireReasonForCodeGenerationStaticText"
												>Require Reason for Code Generation</span
											>
											<div class="column">
												<mat-slide-toggle
													[(ngModel)]="editCompany.requireReasonForCodeGeneration"
													[disabled]="!canEditCompanySetting || isCompanyAdmin"
													data-automation-id="companySettings-requireReasonForCodeGenerationToggle"
												>
												</mat-slide-toggle>
											</div>
										</span>
									}
								</div>
							</section>
						}
						<!-- Privacy & Compliance -->
						<section class="company-settings-section">
							<h4 class="company-settings-section-header" i18n="@@companyAbout-privacyAndCompliance">
								Privacy & Compliance
							</h4>
							<div class="company-settings-section-body column spacing-24">
								@if (isOracle || isSentriKeyAccessUser) {
									<span class="row">
										<span
											class="column width-100-grey"
											i18n="@@companyAbout-hideFromPublicDirectory"
											data-automation-id="companySettings-HideFromPublicDirectoryStaticText"
											>Hide from Public Directory</span
										>
										<div class="column">
											<mat-slide-toggle
												[(ngModel)]="editCompany.hideFromPublicDirectory"
												[disabled]="!canEditCompanySetting || isCompanyAdmin"
												data-automation-id="companySettings-HideFromPublicDirectoryToggle"
											>
											</mat-slide-toggle>
										</div>
									</span>
								}
								<span class="row">
									<span class="column width-100-grey" i18n="@@companyAbout-viewDeidentification">
										What is the time frame before the company undergoes de-identification?
									</span>
									<div class="column">
										<mat-form-field
											subscriptSizing="dynamic"
											appearance="outline"
											class="row input-container-width-200"
										>
											<mat-label i18n="@@companyAbout-editDeidentification">Months</mat-label>
											<input
												matInput
												[(ngModel)]="editCompany.deidentification"
												[disabled]="!canEditCompanySetting || isCompanyAdmin"
												type="number"
												required
												min="1"
												max="48"
												data-automation-id="months-input"
											/>
											<mat-error i18n="@@companyAbout-deidentificationMonthsError" data-automation-id="months-error">
												The value entered is invalid. Please enter a value between 1 and 48.
											</mat-error>
										</mat-form-field>
									</div>
								</span>
							</div>
						</section>
						<!-- System Integrations -->
						@if (hasSystemIntegrationsContent()) {
							<section class="company-settings-section">
								<h4 class="company-settings-section-header" i18n="@@companyAbout-systemIntegrations">
									System Integrations
								</h4>
								<div class="company-settings-section-body column spacing-24">
									@if (isSentriKeyAccessUser || (isEditingActiveCompany && !!this.company.ajaxEnabled)) {
										<span class="row">
											<span class="column width-100-grey" i18n="@@companyAbout-ajaxIntegration2">AJAX Integration</span>
											<div class="column">
												@if (isSentriKeyAccessUser) {
													<mat-slide-toggle
														[(ngModel)]="editCompany.ajaxEnabled"
														(ngModelChange)="onAjaxToggleChange($event)"
														[disabled]="!hasGCM"
														data-automation-id="ajax-integration-toggle"
													>
													</mat-slide-toggle>
												}
											</div>
										</span>
									}
									@if (
										(isSentriKeyAccessUser || (isCompanyAdmin && isEditingActiveCompany)) && editCompany.ajaxEnabled
									) {
										<span class="row">
											<span
												class="column width-100-grey small-margin-left"
												i18n="@@companyAbout-ajaxIntegrationUsername"
												>Username</span
											>
											<div class="column limit-ajax-height-input">
												<mat-form-field
													subscriptSizing="dynamic"
													appearance="outline"
													class="row input-container-width-200"
													[formGroup]="ajaxFormGroup"
													[floatLabel]="
														ajaxFormGroup.get('ajaxUsername')?.invalid && ajaxFormGroup.get('ajaxUsername')?.touched
															? 'always'
															: 'auto'
													"
												>
													<mat-label>
														<span i18n="@@companyAbout-Username">Username</span>
														@if (isAjaxUsernameRequired()) {
															<span class="required-asterisk"> *</span>
														}
													</mat-label>
													<input
														matInput
														formControlName="ajaxUsername"
														data-automation-id="ajax-user-id-input"
														autocomplete="new-password"
														[disabled]="!hasGCM && !isCompanyAdmin"
													/>
												</mat-form-field>
											</div>
										</span>
									}
									@if (
										(isSentriKeyAccessUser || (isCompanyAdmin && isEditingActiveCompany)) && editCompany.ajaxEnabled
									) {
										<span class="row">
											<span
												class="column width-100-grey small-margin-left"
												i18n="@@companyAbout-ajaxIntegrationPassword"
												>Password (Write Only)</span
											>
											<div class="column">
												<mat-form-field
													appearance="outline"
													class="row input-container-width-200"
													subscriptSizing="dynamic"
													[formGroup]="ajaxFormGroup"
													[floatLabel]="
														ajaxFormGroup.get('ajaxPassword')?.invalid && ajaxFormGroup.get('ajaxPassword')?.touched
															? 'always'
															: !this.isInvalidString(this.company.ajaxUsername)
																? 'always'
																: 'auto'
													"
												>
													<mat-label>
														<span i18n="@@companyAbout-password">Password</span>
														@if (isAjaxPasswordRequired()) {
															<span class="required-asterisk"> *</span>
														}
													</mat-label>
													<input
														matInput
														formControlName="ajaxPassword"
														[type]="hidePwd ? 'password' : 'text'"
														data-automation-id="ajax-pass-input"
														autocomplete="new-password"
														[disabled]="!hasGCM && !isCompanyAdmin"
														[placeholder]="!this.isInvalidString(this.company.ajaxUsername) ? '•••••••••••' : ''"
													/>
													<mat-icon
														matSuffix
														(click)="hidePwd = !hidePwd"
														data-automation-id="hide-pwd-ajax-button"
														class="hidden-icon"
														>{{ hidePwd ? 'visibility_off' : 'visibility' }}</mat-icon
													>
												</mat-form-field>
											</div>
										</span>
									}
									@if (isOracle) {
										<span class="row">
											<span class="column width-100-grey" i18n="@@companyAbout-editApiEnabled"
												>Will the company be using our API?</span
											>
											<div class="column">
												<mat-slide-toggle
													[(ngModel)]="editCompany.apiEnabled"
													[disabled]="!canEditCompanySetting || isCompanyAdmin"
												></mat-slide-toggle>
											</div>
										</span>
									}
									@if (isOracle) {
										<div class="row company-settings-top-margin">
											<div class="column kong-usernames-field-wrapper">
												<mat-form-field
													subscriptSizing="dynamic"
													class="kong-usernames-full-width"
													appearance="outline"
												>
													<mat-label i18n="@@addCompanyAbout-kongUsernames" data-automation-id="kong-usernames-label"
														>Kong Usernames (exact match)</mat-label
													>
													<textarea
														class="api-usernames-box"
														matInput
														[(ngModel)]="editCompany.apiUsernames"
														[disabled]="!canEditCompanySetting || !editCompany.apiEnabled || isCompanyAdmin"
														rows="5"
														[required]="!!editCompany.apiEnabled"
														i18n-placeholder="@@companyAbout-apiUsernamesPlaceholder"
														data-automation-id="kong-usernames-textarea"
													>
													</textarea>
												</mat-form-field>
											</div>
											<div class="column"></div>
											<div class="column"></div>
										</div>
									}
								</div>
							</section>
						}
					</div>
				}
			</div>
		</div>
	}
</div>
<p>&nbsp;</p>
